import { createPromiseClient } from '@bufbuild/connect';
import { ConnectTransportOptions } from '@bufbuild/connect-web';
import { LmsHomewokTeacherAPIServiceV1 } from '@protos/learning_management/lms.hw.teacher.apis_connect';
import { ResponseStatusCodeFunction, lmsTransport, lmsTransportWithLogoutHandler } from './transports';

export const LmsHomewokTeacherAPIServiceV1Client = createPromiseClient(
  LmsHomewokTeacherAPIServiceV1,
  lmsTransport
);

//LmsHomewokTeacherAPIServiceV1
export const useLmsHomewokTeacherAPIServiceV1ClientWithStatusCodeHandler = (options: Partial<ConnectTransportOptions>, responseStatusCodeFunction: ResponseStatusCodeFunction) => createPromiseClient(
  LmsHomewokTeacherAPIServiceV1,
  lmsTransportWithLogoutHandler(options, responseStatusCodeFunction)
);
